import React from 'react';

const InputField = (props) => {
    return (
        <React.Fragment>
            {(props.maxLength) && (
            <span className="p-input__count">{props.value.length}/{props.maxLength}</span>
            )}
            <input className="p-input__text" id={props.id} type={props.type}
                   value={props.value} placeholder={props.placeholder} required={props.isRequired}
                   onChange={e => {
                       if (props.maxLength && e.target.value.length <= props.maxLength) {
                           props.input(props.id, e.target.value)
                       } else {
                           props.input(props.id, e.target.value)
                       }
                   }}
            />
        </React.Fragment>
    )
};

export default InputField